import React from 'react';
import { Link } from 'react-router-dom';
import { SEO_PAGES } from '../../content/seoPages';
import './CommunityLinks.css';

// Home page: links to every search landing page (community + city, wedding services by city, Tamil pages), grouped.
// Families can jump straight to the search they have in mind, and search engines can reach those pages from the home page.
const GROUPS = [
    { key: 'Matrimony', title: 'Matrimony by community' },
    { key: 'Wedding services', title: 'Wedding services by city' },
    { key: 'தமிழ்', title: 'தமிழில்' },
];

const CommunityLinks = () => (
    <section className="hcl" aria-labelledby="hcl-title">
        <div className="hcl__inner">
            <h2 id="hcl-title">Find what you are looking for</h2>
            <div className="hcl__grid">
                {GROUPS.map(({ key, title }) => {
                    const pages = SEO_PAGES.filter(page => page.group === key);
                    if (!pages.length) return null;
                    return (
                        <nav key={key} aria-label={title}>
                            <h3>{title}</h3>
                            <ul>
                                {pages.map(page => <li key={page.path}><Link to={page.path}>{page.name}</Link></li>)}
                            </ul>
                        </nav>
                    );
                })}
            </div>
        </div>
    </section>
);

export default CommunityLinks;
